import * as THREE from "three";
import { fitToHeight } from "../core/modelFit.js";
import { CharacterAnimator } from "./CharacterAnimator.js";

/**
 * A hub NPC (blacksmith / merchant / innkeeper). Stands idle at its station,
 * turns to face the player when they come near, and carries a floating
 * nameplate. Interaction (opening its panel) is handled by the Game via
 * proximity + the E key.
 */
export class Npc {
  constructor(scene, registry, def) {
    this.scene = scene;
    this.type = def.type;
    this.name = def.name;
    this.pos = new THREE.Vector3(def.x, 0, def.z);
    this.radius = 0.6;
    this.mesh = new THREE.Group();

    if (registry.has(def.model)) {
      const m = registry.instance(def.model);
      fitToHeight(m, 1.8);
      m.rotation.y = def.face || 0;
      m.traverse((o) => { if (o.isMesh) o.castShadow = true; });
      this.mesh.add(m);
      let clips = m.animations ? m.animations.slice() : [];
      clips = clips.concat(registry.clips("anim/kaykit_general"), registry.clips("anim/kaykit_movement"));
      if (clips.length) { this.animator = new CharacterAnimator(m, clips); this.animator.setMoving(false); }
    } else {
      const box = new THREE.Mesh(new THREE.BoxGeometry(0.8, 1.7, 0.6), new THREE.MeshStandardMaterial({ color: 0x9a7b5a }));
      box.position.y = 0.85; this.mesh.add(box);
    }

    this._nameplate(def.name);
    this.mesh.position.copy(this.pos);
    scene.add(this.mesh);
  }

  _nameplate(name) {
    const cv = document.createElement("canvas"); cv.width = 256; cv.height = 48;
    const c = cv.getContext("2d");
    c.font = "bold 26px Trebuchet MS"; c.textAlign = "center"; c.textBaseline = "middle";
    c.lineWidth = 6; c.strokeStyle = "#000"; c.strokeText(name, 128, 24);
    c.fillStyle = "#ffe08a"; c.fillText(name, 128, 24);
    this._npTex = new THREE.CanvasTexture(cv);
    const spr = new THREE.Sprite(new THREE.SpriteMaterial({ map: this._npTex, transparent: true, depthTest: false }));
    spr.scale.set(2.7, 0.5, 1); spr.position.y = 2.35; spr.renderOrder = 998;
    this.mesh.add(spr);
  }

  update(dt, player) {
    if (this.animator) this.animator.update(dt);
    const dx = player.pos.x - this.pos.x, dz = player.pos.z - this.pos.z;
    if (dx * dx + dz * dz < 100) this.mesh.rotation.y = Math.atan2(dx, dz);   // face the player
  }

  dispose() { this.scene.remove(this.mesh); this._npTex?.dispose(); }
}
